import React from 'react';


export default ({children}) => {
  return <div style={{'marginBottom': '20px'}}>{children}</div>
}